import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Lightbox, LightboxConfig } from "ngx-lightbox";

@Component({
  selector: "app-right-widget",
  templateUrl: "./right-widget.component.html",
  styleUrls: ["./right-widget.component.css"],
})
export class RightWidgetComponent implements OnInit {
  public yt_iframe_html: any;
  public youtubeUrl = "https://www.youtube.com/embed/J7NIIl30qCs";
  public _albums: any = [];

  constructor(
    private sanitizer: DomSanitizer,
    private _lightboxConfig: LightboxConfig,
    private _lightbox: Lightbox
  ) {
    this.yt_iframe_html = `<iframe [class.thumbnail]="thumbnail" [src]="${this.sanitizer.bypassSecurityTrustResourceUrl(
      this.youtubeUrl
    )}" width="560" height="315" frameborder="0" webkitallowfullscreen mozallowfullscreen
    allowfullscreen></iframe>`;
    for (let i = 1; i <= 2; i++) {
      const src = "assets/images/Picture" + i + ".png";
      const thumb = "assets/images/Picture" + i + ".png";
      const album = {
        src: src,
        thumb: thumb,
      };
      this._albums.push(album);
    }
  }

  open(index: number): void {
    this._lightbox.open(this._albums, index, {
      wrapAround: true,
      disableScrolling: true,
      alwaysShowNavOnTouchDevices: true,
      centerVertically: true,
    });
  }

  close(): void {
    this._lightbox.close();
  }

  ngOnInit() {}
}
